import Repository from './Repository'
import config from './config'

export default class OpenAPIRepository extends Repository {
  constructor() {
    super({ baseURL: config.apiBaseURL })
  }
}
